export default __webpack_public_path__ + "static/media/mainImage.e248f229.png";